import { render, staticRenderFns } from "./UploadPayslip.vue?vue&type=template&id=feb1ce3c&scoped=true&"
import script from "./UploadPayslip.vue?vue&type=script&lang=js&"
export * from "./UploadPayslip.vue?vue&type=script&lang=js&"
import style0 from "./UploadPayslip.vue?vue&type=style&index=0&id=feb1ce3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb1ce3c",
  null
  
)

export default component.exports